<template>
   <v-container>
    <v-row>
      <v-col cols="2">
        <v-select
          class="sharedFund-editDialog-fiscalYear"
          id="sharedFundFYSelectField"
          label="Fiscal Years"
          :items="getFiscalYears"
          v-model="editedItem.fiscalYear"
          :readonly="!isNewItem" :tabindex="!isNewItem ? -1 : 0"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
          class="sharedFund-editDialog-type"
          id="sharedFundTypeSelectField"
          label="Fund Type"
          :autofocus="true"
          :items="fundType"
          item-text="description"
          item-value="name"
          v-model="editedItem.type"
          @input="handleFundDataChanges"
          @focus="roundAmount"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field
          class="sharedFund-editDialog-fund"
          id="sharedFundFundTextField"
          label="Fund Number"
          v-model="editedItem.fund"
          :rules="[lengthValidation, checkDuplicateValues, ...reqdSelectValidation()]"
          @input="handleFundDataChanges"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          class="sharedFund-editDialog-description"
          id="sharedFundDescriptionTextField"
          label="Description"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.description"
          @input="handleFundDataChanges"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-select
          class="sharedFund-editDialog-bankName"
          id="sharedFundBankNameSelectField"
          label="Bank"
          :items="banks"
          item-text="bankName"
          item-value="_id"
          v-model="editedItem.bank"
          @input="handleFundDataChanges"
        ></v-select>
      </v-col>
      <v-col cols="3">
      <v-text-field
        class="sharedFund-editDialog-totalEncumberedAmount"
        id="sharedFundTotalEncumberedAmountTextField"
        label="Total Encumbered Amount"
        v-if="isFundsOnly"
        v-model.number="editedItem.totalEncumberedAmount"
        @input="handleFundDataChanges"
      ></v-text-field>
      </v-col>
      <v-col cols="3">
        <h5>LastWarrant</h5>
        <div>{{editedItem.lastWarrant}}</div>
      </v-col>
      <v-col cols="3">
        <h5>LastPayment</h5>
        <div>{{editedItem.lastPayment}}</div>
      </v-col>
      <v-col cols="3" />
    </v-row>
    <v-row>
      <v-col cols="3">
      <v-text-field
          class="sharedFund-editDialog-crossReferenceFund"
          id="sharedFundCrossReferenceFundTextField"
          label="Cross Reference Fund"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.crossReferenceFund"
          @blur="padWithZeros"
          @keydown.enter="padWithZeros"
          @input="handleFundDataChanges"
        ></v-text-field>
      </v-col>
      <v-col cols="3">
      <v-text-field
          class="sharedFund-editDialog-altKey"
          id="sharedFundAltKeyTextField"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.altKey"
          label="Alt Key"
          @input="handleFundDataChanges"
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="3">
        <v-text-field
          v-model="editedItem.clearingFund"
          class="sharedFund-editDialog-clearingFund"
          id="sharedFundClearingFundTextField"
          label="Clearing Fund Number"
          v-if="isClearingFund"
        ></v-text-field>
      </v-col> -->
      <v-col cols="3">
        <v-text-field
          class="sharedFund-editDialog-line"
          id="sharedFundLineTextField"
          label="Line"
          v-model.number="editedItem.line"
          type="number"
          @input="handleFundDataChanges"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          class="sharedFund-editDialog-line"
          id="sharedFundLineTextField"
          label="Invested Amount for Interest Calculations"
          v-model="editedItem.investedAmountInterestCalculations"
          @input="handleFundDataChanges"
          @blur="roundAmount"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-checkbox
          class="sharedFund-editDialog-isRequiredUnit"
          id="sharedFundRequiredUnitCheckboxField"
          v-model="editedItem.isRequiredUnit"
          label="Required Unit Code"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="sharedFund-editDialog-calculateInterest"
          id="sharedFundCalculateInterestCheckboxField"
          v-model="editedItem.calculateInterest"
          label="Calculate Interest"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="sharedFund-editDialog-isExcludedFromExport"
          id="sharedFundIsExcludedFromExportCheckbox"
          v-model="editedItem.isExcludedFromExport"
          label="Exclude from Export"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-select
          class="shared-fund-edit-dialog-back-page"
          id="sharedFundBackPageSelectField"
          label="Back Page"
          :items="sharedBackPageEnum"
          item-text="description"
          item-value="name"
          v-model="editedItem.backPage"
          @input="handleFundDataChanges"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-checkbox
          class="sharedFund-editDialog-isSubledger"
          id="sharedFundIsSubledgerCheckbox"
          v-model="editedItem.isSubledger"
          label="Subledger"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="sharedFund-editDialog-isAlwaysPrint"
          id="sharedFundIsAlwaysPrintCheckbox"
          v-model="editedItem.isAlwaysPrint"
          label="Always Print"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="sharedFund-editDialog-trustAndAgency"
          id="sharedFundTrustAndAgencyCheckbox"
          v-model="editedItem.isTrustAndAgency"
          label="Trust And Agency"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="shared-fund-edit-dialog-enableReconciliation"
          id="sharedFundenableReconciliationCheckbox"
          label="Enable Reconciliation"
          v-model="editedItem.enableReconciliation"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
       <v-col cols="3">
        <v-checkbox
          class="shared-fund-edit-dialog-isPrintEON"
          id="sharedFundisPrintEONCheckbox"
          label="Print Estimate of Need"
          v-model="editedItem.isPrintEON"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="shared-fund-edit-dialog-isPrintEON"
          id="sharedFundProtest"
          label="Protest Tax"
          v-model="editedItem.protest"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="shared-fund-edit-dialog-isExcludeFromRemitWarrant"
          id="sharedFundIsExcludeFromRemitWarrantCheckbox"
          label="Exclude from Remit Warrant"
          v-model="editedItem.isExcludeFromRemitWarrant"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
      <v-col cols="3">
        <v-checkbox
          class="shared-fund-edit-dialog-paymentNumberFromWarrant"
          id="sharedFundPaymentNumberFromWarrantCheckbox"
          label="Payment Number = Warrant Number"
          v-model="editedItem.paymentNumberFromWarrant"
          @change="handleFundDataChanges"
        ></v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import { getFYList, checkDuplicate, validateInputLength } from '../../../util/shared/tmc-global';
import { amountFormat, amountToNumber, checkStringEmptiness } from '../../../util/shared/vue-global';
import { isBudgetedFundOrCashFund } from '../shared.util';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

const bankCrudKey = 'sharedBank';

export default {
  name: 'FundEditedItem',
  mixins: [GlobalToCaps],
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'fund-dialog',
    },
  },
  created() {
    this.loadBanks({
      criteria: {},
      baseCrudKey: bankCrudKey,
    });
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      warSettingItem: (state) => state.SystemConfig.warSettingItem,
      fundType: (state) => state.enums.SharedFundTypeEnum,
      getFiscalYears: (state) => {
        const regYears = state.shared.fund.regYears || {};
        return getFYList(regYears);
      },
      fundList: (state) => state.base.crud.items.sharedFund,
      sharedBackPageEnum: (state) => {
        const storedBackPage = state.enums.sharedBackPageEnum || [];
        return [
          { name: null, description: '' },
          ...storedBackPage,
        ];
      },
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    banks() {
      const bankObjs = this.items(bankCrudKey) || [];
      return [{ _id: null, bankName: '' }, ...bankObjs];
    },
    changes() {
      return this.editedItem.changes || [];
    },
    isFundsOnly() {
      return this.warSettingItem && this.warSettingItem.fundsOnly;
    },
    isClearingFund() {
      return this.warSettingItem && this.warSettingItem.clearingFund;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    /*
      0000 fund number can be duplicate so adding a flag isFundZero
      to allow duplicate for 0000 fund only
    */
    checkDuplicateValues() {
      if (!isBudgetedFundOrCashFund(this.editedItem.type) && this.editedItem.fund == null) {
        return true;
      }
      return this.checkDuplicate({
        stateArr: this.fundList,
        fieldName: 'fund',
        val: this.editedItem,
        isNewItem: this.isNewItem,
        isFundZero: true,
      });
    },
    lengthValidation() {
      return validateInputLength({
        fieldName: 'fund',
        label: 'Fund',
        val: this.editedItem,
        requiredLength: 4,
      });
    },
    /* Todo - need to update this validation */
    // emptyOrLengthValidation() {
    //   if (checkStringEmptiness(this.editedItem.crossReferenceFund)) return true;
    //   return validateInputLength({
    //     fieldName: 'crossReferenceFund',
    //     label: 'Shared Fund',
    //     val: this.editedItem,
    //     requiredLength: 4,
    //   });
    // },
  },
  methods: {
    checkDuplicate,
    amountFormat,
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    handleFundDataChanges() {
      this.$emit('fundEmitData');
    },
    reqdSelectValidation() {
      return [
        (value) => {
          if (!isBudgetedFundOrCashFund(this.editedItem.type)) {
            return true;
          }
          return !!value || 'Required';
        },
      ];
    },
    padWithZeros() {
      if (!checkStringEmptiness(this.editedItem.crossReferenceFund)) {
        const crossRefFundNumbers = [];
        let allCrossRefFund = this.editedItem.crossReferenceFund || '';
        allCrossRefFund = allCrossRefFund.toString().replace(/\s/g, '').split(',');
        allCrossRefFund.forEach((crossRefFundNo) => {
          const paddedFundNum = String(crossRefFundNo).trim().padStart(4, '0');
          crossRefFundNumbers.push(paddedFundNum);
        });
        this.editedItem.crossReferenceFund = crossRefFundNumbers;
      }
      return this.editedItem.crossReferenceFund;
    },
    roundAmount() {
      this.editedItem.investedAmountInterestCalculations = amountFormat(
        amountToNumber(this.editedItem.investedAmountInterestCalculations),
      );
      return this.editedItem.investedAmountInterestCalculations;
    },
  },

};
</script>
